// src/components/common/BubbleBackground.jsx

//import "../styles/BubbleBackground.css";

export default function BubbleBackground() {
    return (
        <div className="bg-bubbles" aria-hidden="true">
            {Array.from({ length: 32 }).map((_, i) => {
                let bubbleClass = "bubble blue"; // default

                // 4-color balanced distribution (NOT blue-heavy)
                if (i % 8 === 1 || i % 8 === 6) bubbleClass = "bubble orange";
                if (i % 8 === 2 || i % 8 === 7) bubbleClass = "bubble cyan";
                if (i % 8 === 4) bubbleClass = "bubble purple";

                return <span key={i} className={bubbleClass} />;
            })}
        </div>
    );
}